import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import { blue, blueGrey, brown, pink, red } from "@mui/material/colors";
import { SetStateAction } from "react";

interface AlertMessageProps {
  type: "error" | "warn" | "alert" | "info";
  returnType: string;
  open: boolean;
  errorCode?: string;
  message?: string;
  fieldParam?: string;
  onResult: (type: string) => void;
  handleClose: () => void;
}

export const AlertMessage = ({
  type = "warn",
  returnType,
  open,
  errorCode,
  message,
  fieldParam,
  onResult,
  handleClose,
}: AlertMessageProps) => {
  const { t: tError } = useTranslation("errors");

  if (!open || !errorCode) return null;

  // console.log("---errmessage ->", t("ER_NotLoggedIn"));
  // 翻訳キーがない場合はERR_UNKNOWN
  // const errorMessage = t(errorCode as Parameters<typeof t>[0], {
  //   defaultValue: t("ER_Unknown"),
  //   field: fieldParam,
  // });
  const errorMessage = `${tError(errorCode)} ${message && message !== "undefined" ? message : ""}`;

  // const handleClose = () => {
  //   console.log("--s0699--", returnType);
  //   onClose(returnType);
  // };

  const handleOk = () => {
    onResult(returnType);

    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Icon>
          {type === "error" ? (
            <ErrorIcon sx={{ color: red[400] }} />
          ) : type === "info" ? (
            <InfoIcon sx={{ color: blue[400] }} />
          ) : (
            <WarningIcon sx={{ color: brown[400] }} />
          )}
        </Icon>
        {type}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {errorMessage}
          {message && ` ${message}`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
